export interface PuiNavRoute {
  name?: string;
  icon?: string;
  divider?: boolean;
  active?: boolean;
}
